import { 
    INVOICES_CUSTOMER_FETCH_SUCCESS,
    INVOICES_CUSTOMER_FETCH_FAILURE,
    INVOICES_CUSTOMER_FETCH_REQUEST,
    INVOICES_CUSTOMER_ADD_FAILURE,
    INVOICES_CUSTOMER_ADD_SUCCESS,
    INVOICES_CUSTOMER_ADD_REQUEST
  } from "../actions/actionTypes";
  
  const initialState = {
    loading: false,
    error: null,
    invoicesCustomer: [],
  };
  
  const InvoicesCustomerReducer = (state = initialState, action) => {
    switch (action.type) {
      case INVOICES_CUSTOMER_FETCH_REQUEST:
        return { ...state, loading: true, error: null };
        
      case INVOICES_CUSTOMER_FETCH_SUCCESS:
        return { ...state, loading: false, invoicesCustomer: action.payload }; 
  
      case INVOICES_CUSTOMER_FETCH_FAILURE:
        return { ...state, loading: false, error: action.error };

      case INVOICES_CUSTOMER_ADD_REQUEST:
            return { ...state, loading: true, error: null };
            
            case INVOICES_CUSTOMER_ADD_SUCCESS:
              
              return {
                  ...state,
                  loading: false,
                  invoicesCustomer: [...state.invoicesCustomer, action.payload],
              };
      
      case INVOICES_CUSTOMER_ADD_FAILURE:
            return { ...state, loading: false, error: action.error };
      
      default:
        return state;
    }
  };
  
  export default InvoicesCustomerReducer;
  